// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageContainer {
  width: 80vw;
}

/* Message box font */
.senderOutput {
  font-weight: bold;
  margin: 0em;
}

.marginNone {
  margin: 0em;
}

.paddingRight {
  padding-right: 10px;
}
.textOutput {
  padding-top: 10px;
  overflow: auto;
}
.mat-card{
  display:flex;
  flex-direction: column;
}

.mat-card-header {
  flex-shrink: 0;
}

.mat-card-content{
  flex-grow: 1;
  overflow: auto;
}

/*skrijem tab pa dam column podatke*/
@media(min-width: 1050px){

  .mobileHide {
    display: none;
    backface-visibility: hidden;
  }

}

@media(max-width: 1050px){

  .desktopHide {
    display: none;
  }

}
/*FFF5E3  FFE8BF*/
mat-card {
  background-color: #FFE8BF;
}

:host ::ng-deep angular-editor#myEditor .angular-editor-button[title="Insert Image"]{
  display: none
  }
:host ::ng-deep angular-editor#myEditor .angular-editor-button[title="Insert Video"]{
  display: none
  }
:host ::ng-deep angular-editor#myEditor .angular-editor-button[title="Clear Formatting"]{
  display: none
  }
:host ::ng-deep angular-editor#myEditor .angular-editor-button[title="HTML Code"]{
  display: none
  }


.leftAlign {
  display: block;
  position: relative;
  float: left;
}

.rightAlign {
  display: block;
  position: relative;
  float: right;
}

/*messages*/
ul{
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li{
  display:inline-block;
  clear: both;
  padding: 20px;
  max-width: 80vw;
  min-width: 100px;
  font-family: Helvetica, Arial, sans-serif;
}

@media(min-width: 800px) {
  .himLeft {
    display:inline-block;
    clear: both;
    float: left;
    padding-left:20px;
  }

  .meRight {
    display:inline-block;
    clear: both;
    float: right;
    padding-right: 20px;
  }
}
@media(max-width:800px){
  .himLeft {
    display:inline-block;
    clear: both;
    float: left;
  }

  .meRight {
    display:inline-block;
    clear: both;
    float: right;
  }
}


.him + .me{
  border-bottom-right-radius: 5px;
}

.me + .me{
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.me:last-of-type {
  border-bottom-right-radius: 5px;
}

.paddingNone {
  padding-bottom: 5px;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/uredi-task/messages/messages.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,oCAAoC;AACpC;;EAEE;IACE,aAAa;IACb,2BAA2B;EAC7B;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;AAEF;AACA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE;EACA;AACF;EACE;EACA;AACF;EACE;EACA;AACF;EACE;EACA;;;AAGF;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;IACE,oBAAoB;IACpB,WAAW;IACX,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;IACpB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;EACd;AACF;;;AAGA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".messageContainer {\n  width: 80vw;\n}\n\n/* Message box font */\n.senderOutput {\n  font-weight: bold;\n  margin: 0em;\n}\n\n.marginNone {\n  margin: 0em;\n}\n\n.paddingRight {\n  padding-right: 10px;\n}\n.textOutput {\n  padding-top: 10px;\n  overflow: auto;\n}\n.mat-card{\n  display:flex;\n  flex-direction: column;\n}\n\n.mat-card-header {\n  flex-shrink: 0;\n}\n\n.mat-card-content{\n  flex-grow: 1;\n  overflow: auto;\n}\n\n/*skrijem tab pa dam column podatke*/\n@media(min-width: 1050px){\n\n  .mobileHide {\n    display: none;\n    backface-visibility: hidden;\n  }\n\n}\n\n@media(max-width: 1050px){\n\n  .desktopHide {\n    display: none;\n  }\n\n}\n/*FFF5E3  FFE8BF*/\nmat-card {\n  background-color: #FFE8BF;\n}\n\n:host ::ng-deep angular-editor#myEditor .angular-editor-button[title=\"Insert Image\"]{\n  display: none\n  }\n:host ::ng-deep angular-editor#myEditor .angular-editor-button[title=\"Insert Video\"]{\n  display: none\n  }\n:host ::ng-deep angular-editor#myEditor .angular-editor-button[title=\"Clear Formatting\"]{\n  display: none\n  }\n:host ::ng-deep angular-editor#myEditor .angular-editor-button[title=\"HTML Code\"]{\n  display: none\n  }\n\n\n.leftAlign {\n  display: block;\n  position: relative;\n  float: left;\n}\n\n.rightAlign {\n  display: block;\n  position: relative;\n  float: right;\n}\n\n/*messages*/\nul{\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\nul li{\n  display:inline-block;\n  clear: both;\n  padding: 20px;\n  max-width: 80vw;\n  min-width: 100px;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n@media(min-width: 800px) {\n  .himLeft {\n    display:inline-block;\n    clear: both;\n    float: left;\n    padding-left:20px;\n  }\n\n  .meRight {\n    display:inline-block;\n    clear: both;\n    float: right;\n    padding-right: 20px;\n  }\n}\n@media(max-width:800px){\n  .himLeft {\n    display:inline-block;\n    clear: both;\n    float: left;\n  }\n\n  .meRight {\n    display:inline-block;\n    clear: both;\n    float: right;\n  }\n}\n\n\n.him + .me{\n  border-bottom-right-radius: 5px;\n}\n\n.me + .me{\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.me:last-of-type {\n  border-bottom-right-radius: 5px;\n}\n\n.paddingNone {\n  padding-bottom: 5px;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
